import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditCollection from "../../components/collections/FormAddEditCollection";
import { useGetCollectionById } from "../../hooks/collections/useGetCollectionById";
import { CircularProgress, Box } from "@mui/material";

const EditCollection = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { collection, isLoading } = useGetCollectionById(id);

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            {isLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <FormAddEditCollection
                    isEdit={true}
                    currentData={collection}
                    onSubmitSuccess={() => navigate("/collections")}
                />
            )}
        </WrapperSection>
    );
};

export default EditCollection;
